import React, { useMemo } from 'react';

import { Button, ErrorText, Flex, Text } from '@betterment/style-closet-react';
import { FormikErrors } from 'formik';

import StickyFooter from '../../Shared/components/StickyFooter';
import { Allocations } from '../data';
import { totalAllocationWeight } from '../models';

interface Props {
  currentAllocations: Allocations;
  errors: FormikErrors<Allocations>;
}

const PortfolioCustomizationFooter: React.FC<React.PropsWithChildren<Props>> = ({ currentAllocations, errors }) => {
  const totalWeight = useMemo(() => {
    return totalAllocationWeight(currentAllocations);
  }, [currentAllocations]);

  return (
    <StickyFooter py={[5, 3]}>
      <Flex role="row" flexDirection="row" alignItems="center" aria-label="Footer">
        <Button type="submit">Continue</Button>
        <Flex pl="5" flexDirection="column">
          <Text>
            Total weight: <Text color={totalWeight === 100 ? 'bmtVizTeal90' : 'bmtGrey90'}>{totalWeight}%</Text>
          </Text>
          {errors.form && <ErrorText color="bmtRed">{errors.form}</ErrorText>}
        </Flex>
      </Flex>
    </StickyFooter>
  );
};

export default PortfolioCustomizationFooter;
